import React, { useEffect, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowLeft,
  faTrash
} from "@fortawesome/free-solid-svg-icons";
import {
  Button,
  Card,
  Form,
  Table,
} from "@themesberg/react-bootstrap";
import {
  confirmDeleteToast,
  confirmRequestToast,
  sendError,
  sendSuccess,
  status,
} from "../helpers/Helper";
import { Model } from "../components/Model";
import { Textbox } from "../components/Textbox";
import { SelectBox } from "../components/SelectBox";
import { API_URL_ENDPOINT } from "../appsetting";
import TextEditor from "../components/TextEditor";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useApi } from "../helpers/useApi";
import { Avatar } from "@mui/material";
import {
  faRefresh,
  faClose,
} from "@fortawesome/free-solid-svg-icons";
import DropzoneUpload from "../components/DropzoneUpload";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import OffCanvas from "../components/OffCanvas";
import LoadAlert from "../components/LoadAlert";
import Bilty from "../components/Bilty";
import { Routess } from "../Routes/routes";

export const TruckTypeDetail = () => {
  const callApi = useApi();
  const { id } = useParams();
  const navigate = useNavigate();
  const [data, setData] = useState({});
  const [trasnsporterRequest, setTransporterRequest] = useState([]);
  const methods = useForm();
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors, isSubmitting },
    watch,
    setValue,
  } = methods;

  const isMinPlus = watch("isMinPlus");

  const [dataLoading, setDataLoading] = useState(false);
  const [showModel, setShowModel] = useState(false)

  useEffect(() => {
    getData();
  }, []);


  const getData = async (cp = null) => {
    try {
      setDataLoading(true);
      const response = await callApi(API_URL_ENDPOINT.Truck + `/types/${id}`);
      if (response.status) {
        if(response?.data == null){
          goBack();
          return;
        }
        setData(response?.data ?? {});
      }
    } catch {
      setData({});
    } finally {
      setDataLoading(false);
    }
  };


  const onFormSubmit = async (data) => {
    try {
      const payload = {
        "truckTypeID": parseInt(id, 10) || 0,
        "minCapacity": parseInt(data.minCapacity, 10),
        "maxCapacity": parseInt(data.maxCapacity, 10) || null,
        "isMinPlus": String(data.isMinPlus).toLowerCase() === "true"
      };

      const response = await callApi(
        API_URL_ENDPOINT.Truck + "/add-passing-ton/" + id,
        {
          method: "POST",
          data: payload,
        }
      );
      if (response.status) {
        setShowModel(false);
        reset();
        getData();
        sendSuccess(response.message);
      } else {
        throw Error(response.message || "Something Went Wrong");
      }
    } catch (ex) {
      sendError(ex.message);
    }
  };

  const deleteType = async () => {
    try {
      const response = await callApi(
        API_URL_ENDPOINT.Truck + "/types/" + id,
        {
          method: "DELETE",
          data: null,
        }
      );
      if (response.status) {
        goBack()
        sendSuccess(response.message);
      } else {
        throw Error(response.message || "Something Went Wrong");
      }
    } catch (ex) {
      sendError(ex.message);
    }
  }

  const goBack = ()=>{
    navigate(Routess.TruckTypes.path)
  }
  return (
    <>
      {/* Add Passing Ton Model */}
      <Model show={showModel} size={"md"}>
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h5 className="mb-0">Add Passing Ton</h5>
          <Button
            variant=""
            style={{ width: 30, height: 30, outline: "none" }}
            className="btn-sm rounded-circle"
            onClick={() => setShowModel(false)}
          >
            <FontAwesomeIcon icon={faClose} />
          </Button>
        </div>
        <FormProvider {...methods}>
          <Form onSubmit={handleSubmit(onFormSubmit)}>
            <div className="row">
              <div className="col-md-12">
                <Form.Group className="mb-3">
                  <Textbox
                    Label="Minimum Value"
                    Placeholder="Enter Minimum Value in TON"
                    name={"minCapacity"}
                    validationRules={{ required: "Capacity is required" }}
                    register={register}
                    errors={errors}
                    watch={watch}
                  />
                </Form.Group>
              </div>
              <div className="col-md-12">
                <Form.Group>
                  <input
                    {...register("isMinPlus")}
                    type="checkbox"
                    style={{ width: 20, height: 20 }}
                    className="form-check-input shadow-none me-2 mt-0"
                  />
                  <Form.Label>
                    Mark as open-ended (e.g., 20+ Ton)
                  </Form.Label>
                </Form.Group>
              </div>
              {!isMinPlus && (

                <div className="col-md-12">
                  <Form.Group className="mb-3">
                    <Textbox
                      Label="Maximum Value"
                      Placeholder="Enter Maximum Value in TON"
                      name={"maxCapacity"}
                      validationRules={{ required: "Capacity is required" }}
                      register={register}
                      errors={errors}
                      watch={watch}
                    />
                  </Form.Group>
                </div>
              )}
            </div>
            <div className="text-end">
              <Button
                type="Button"
                className="me-2"
                variant="outline-danger"
                onClick={() => setShowModel(false)}
              >
                Close
              </Button>
              <Button
                type="submit"
                className=""
                disabled={isSubmitting}
                variant="success"
              >
                Save Changes
              </Button>
            </div>
          </Form>
        </FormProvider>
      </Model>

      <div className="justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
        <div className="d-block mb-4 mb-xl-0">
          <div className="d-flex align-items-center justify-content-between">
            <div className="d-flex">
              <Button
                variant=""
                style={{ width: 30, height: 30, outline: "none" }}
                onClick={() => navigate(-1)}
                className="btn-sm rounded-circle"
              >
                {<FontAwesomeIcon icon={faArrowLeft} />}
              </Button>
              <h4 className="mb-0 ms-3">Truck Type Details</h4>
            </div>
          </div>
        </div>
      </div>

      <Card border="light" className="shadow-sm mb-4">
        <Card.Body className="py-3">
          <div className="d-flex justify-content-between border-bottom align-items-center pb-3 mb-3">
            <h6 className="m-0">Truck Info : </h6>
            <div>

              <Button
                variant="primary"
                className="btn-sm"
                onClick={() => getData()}
              >
                <FontAwesomeIcon icon={faRefresh} /> Refresh
              </Button>
              <Button
                variant="danger"
                className="btn-sm ms-1"
                onClick={() => confirmDeleteToast(() => deleteType())}
              >
                <FontAwesomeIcon icon={faTrash} /> Delete this Type
              </Button>
            </div>
          </div>

          <div className="d-flex">
            <div>
              {dataLoading ? (
                <Skeleton height={60} width={60} />
              ) : (
                <Avatar
                  className="border p-1"
                  src={data?.icon}
                  variant="square"
                  sx={{ width: 60, height: 60 }}
                />
              )}
            </div>
            <div className="ms-3 w-100">
              <div className="ps-3 w-100 pb-2">
                <h4>
                  {dataLoading ? (
                    <Skeleton height={30} width={200} />
                  ) : data?.name}{" "}
                </h4>
                <div className="d-flex">
                  <div className="me-5">
                    {dataLoading ? (
                      <Skeleton height={20} width={200} />
                    ) : (
                      `7 - 45 Ton`
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Card.Body>
      </Card>

      <Card border="light" className="shadow-sm mb-4">
        <Card.Body className="py-3">
          <div className="d-flex justify-content-between">
            <h6 className="pb-2 mb-3">Passing Tons : </h6>
            <div>
              <Button
                variant="primary"
                style={{ outline: "none" }}
                onClick={() => setShowModel(true)}
                className="btn-sm rounded-circle"
              >
                Add Passing Ton
              </Button></div>
          </div>
          <Table
            responsive
            className="table-centered table-nowrap rounded mb-0"
          >
            <thead className="thead-light">
              <tr>
                <th className="border-0 text-center">#</th>
                <th className="border-0 text-center">Capacity</th>
                <th className="border-0 text-center">Created AT</th>
                <th className="border-0 text-end pe-4">Action</th>
              </tr>
            </thead>
            <tbody>
              {dataLoading ? (
                <tr>
                  <td colSpan="4">
                    <div className="text-center my-3">
                      <span
                        className="spinner-border text-primary"
                        role="status"
                      ></span>
                    </div>
                  </td>
                </tr>
              )
                : data?.passingTons?.length > 0 ? (
                  data?.passingTons.map((item, index) => (
                    <tr key={index}>
                      <td className="text-center align-middle">
                        {index + 1}
                      </td>
                      <td className="fw-bold align-middle text-center">
                        {item.minCapacity
                          ? `${item.minCapacity}${item.isMinPlus ? "+" : " -"} ${item.maxCapacity ?? ""} Ton`
                          : "-"}

                      </td>
                      <td className="fw-bold text-center align-middle">
                        {item?.createdAt}
                      </td>
                      <td className="text-end align-middle">
                        {/* <Button variant="primary" className="btn-sm" onClick={()=>handleView(item.id)}>View Details</Button> */}
                        {/* <Button onClick={handleDelete} variant="danger" className="btn-sm">Remove</Button> */}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="4" className="text-center">
                      No Data Found
                    </td>
                  </tr>
                )}
            </tbody>
          </Table>
        </Card.Body>
      </Card>
    </>
  );
};
